import {connect} from 'react-redux';
import React from 'react';

import EventIcons from '../common/EventIcons/EventIcons';
import EventParticipants from '../common/HomeEventParticipants/HomeEventParticipants';
import EventQuests from '../common/CommonEventQuests/CommonEventQuests';
import HasData from '../../../validate/HasData';
import JoinEvent from '../common/JoinEvent/JoinEvent';
import Link from '../../../elements/Link';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import LoadEvent from '../../../loaders/LoadEvent';
import LoadParticipants from '../../../loaders/LoadParticipants';
import LoadProgram from '../../../loaders/LoadProgram';
import LoadQAQuestions from '../../../loaders/LoadQAQuestions';
import SafeImage from '../../../elements/SafeImage';
import SandboxedContent from '../../../SandboxedContent/SandboxedContent';
import Screen from '../../Screen';
import Scrollable from '../../../elements/Scrollable';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Validate from '../../../validate/Validate';
import WaitWhileBusy from '../../../WaitWhileBusy';
import EventProgramSection from '../common/EventProgramSection/EventProgramSection';
import EventLocation from '../../../elements/EventLocation/EventLocation';
import EventHeaderImage from '../common/EventHeaderImage/EventHeaderImage';

class Previewable extends React.Component {
    render() {
        let {i18n, event, participants} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} returnURL={'../..'} />
                    <hr />
                </div>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <Link href={['/events', event.id, 'info'].join('/')}>
                    <EventHeaderImage event={event} />
                    </Link>
                    <EventIcons i18n={i18n} event={event} />
                    <JoinEvent eventId={event.id} i18n={i18n} />

                    <div className="content">
                        {event.settings.description ? (
                            <div>
                                <h2>{i18n['label.event.info']}</h2>
                                <SandboxedContent content={event.settings.description} fitHeightToContents="fitHeightToContents" />
                            </div>
                        ) : null}
                    </div>
                    <EventLocation event={event} />
                    <EventParticipants i18n={i18n} event={event} participants={this.props.participants} />
                    <EventQuests i18n={i18n} event={event} />
                    <EventProgramSection event={event} />
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedPreviewable = connect((state, props) => {
    let event = state.events[props.eventId].event,
        participants = _(state.events[props.eventId].participants.listed).filter(p => {
            return p.user_id && !p.image_url.match(/no\_avatar\.png$/);
        });

    return {
        event,
        i18n: state.i18n.translations,
        participants: participants.slice(0, 5).value(),
        question: _(state.events[props.eventId].questions.listed).maxBy('lastUpdateTimestamp'),
        news: state.events[props.eventId].news.listed,
    };
})(Previewable);

export default props => (
    <Validate
        validate={state => {
            let subEvents = _.get(state, 'events[' + props.communityId + '].event.subevents');
            if (!_(subEvents).find(se => se.id == props.eventId)) {
                throw new Error('SubEvent not found: ', props.eventId);
            }
        }}>
        <LoadEvent eventId={props.eventId}>
            <LoadParticipants eventId={props.eventId}>
                <LoadQAQuestions eventId={props.eventId}>
                    <LoadProgram eventId={props.eventId}>
                        <WaitWhileBusy>
                            <HasData path={`events[${props.eventId}].event`}>
                                <ConnectedPreviewable {...props} />
                            </HasData>
                        </WaitWhileBusy>
                    </LoadProgram>
                </LoadQAQuestions>
            </LoadParticipants>
        </LoadEvent>
    </Validate>
);
